import { motion } from "framer-motion";

const TEAM = [
  { name: "Jose Chirinos", role: "C.E.O", url: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/utmcg7d9_guaji%20ready.png", bio: "+11 años en trading, 6 años como educador. +6.000 alumnos entrenados. Manejo de cuentas hasta $6M USDT." },
  { name: "Jeffrey Gómez", role: "E.D", url: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/24cj1ln8_WhatsApp%20Image%202026-04-28%20at%202.07.24%20PM.jpeg", bio: "+8 años en el mundo del trading, 5 años como educador de grandes academias mundiales." },
  { name: "Miguel Romero", role: "Dir. Educación", url: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/vjier90o_miguel%20romero.jpeg", bio: "6 años de experiencia en los mercados, 3 años como educador formando a la próxima generación de traders." },
  { name: "Ana Correa", role: "Dir. RR.HH.", url: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/6max1pb9_ana%20correa.jpeg", bio: "5 años de experiencia en el mercado financiero. Educadora especializada en psicotrading y desarrollo del trader." },
];

export default function Team() {
  return (
    <section
      id="nosotros"
      className="relative py-24 md:py-32 bg-black"
      data-testid="team-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="mb-16 max-w-3xl">
          <span className="text-xs font-display uppercase tracking-[0.4em] text-[#BEDD7D]">
            / Nosotros
          </span>
          <h2 className="mt-6 font-display font-bold text-4xl md:text-6xl uppercase tracking-tight leading-none">
            El escuadrón que lidera la{" "}
            <span className="italic text-[#BEDD7D]">misión</span>.
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {TEAM.map((m, i) => (
            <motion.div
              key={m.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.55, delay: (i % 3) * 0.1 }}
              className="group relative rounded-2xl overflow-hidden bg-[#1A2E1A]/30 border border-[#3E4D36]/50 hover:border-[#BEDD7D]/60 transition-all"
              data-testid={`team-${m.name.toLowerCase().replace(/ /g, "-")}`}
            >
              <div className="relative aspect-[4/5] overflow-hidden bg-black">
                <img
                  src={m.url}
                  alt={m.name}
                  className="w-full h-full object-cover transition-all duration-700 grayscale group-hover:grayscale-0 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/20 to-transparent" />
                <div className="absolute top-4 left-4 px-2.5 py-1 bg-[#BEDD7D] text-black text-[10px] font-display font-bold uppercase tracking-widest">
                  {m.role}
                </div>
              </div>
              <div className="p-6">
                <h3 className="font-display font-bold text-xl uppercase tracking-wide">{m.name}</h3>
                <p className="mt-2 text-sm text-white/60 font-body leading-relaxed">{m.bio}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
